import { app, authentication } from "@microsoft/teams-js";
import { setAuthToken } from "./services/ApiAuth";
import { getUserFromJwt, SignedInUser } from "./services/JwtUser";

export async function getAuthToken(): Promise<string | null> {
    try {
        const token = await authentication.getAuthToken();
        setAuthToken(token);
        return token;
    } catch (error: unknown) {
        console.error("Error getting auth token:", error);
        setAuthToken(null);
        return null;
    }
}

// The Teams context is preferred; the SSO token claims fill in anything the context does not provide.
export async function getTeamsUser(): Promise<SignedInUser | null> {
    const tokenUser = getUserFromJwt(await getAuthToken());

    let contextUser: app.UserInfo | undefined;
    try {
        contextUser = (await app.getContext()).user;
    } catch (error: unknown) {
        console.error("Error getting Teams context:", error);
    }

    const id = contextUser?.id || tokenUser?.id || "";
    if (!id) {
        return null;
    }

    return {
        id,
        email: contextUser?.userPrincipalName || tokenUser?.email || "",
        displayName: contextUser?.displayName || tokenUser?.displayName || "",
    };
}
